import React, { useState, Fragment } from "react";
import PropTypes from "prop-types";

// Material-UI Core
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

// Custom Component
import TransferList from "../TransferList/TransferList";
import TransferGroupList from "../TransferList/TransferGroupList";

// Custom Style
import { circulationRecipientFormStyle } from "../../styles/jss/components/circulation/circulationRecipientFormStyle";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={1}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const a11yProps = (index) => {
  return {
    id: `circulation-tab-${index}`,
    "aria-controls": `circulation-tabpanel-${index}`,
  };
};

const useStyles = makeStyles((theme) => circulationRecipientFormStyle(theme));

const CirculationRecipientForm = (props) => {
  const classes = useStyles();
  const {
    recipientType,
    userGroupType,
    internalOnly,

    getUserListLoading,
    getGroupListLoading,
    internalUserList,
    externalUserList,
    userGroupList,

    reciptentChipAdd,
    reciptentChipRemove,

    leftToUserRcpt,
    setLeftToUserRcpt,
    rightToUserRcpt,
    setRightToUserRcpt,

    leftToGroupRcpt,
    setLeftToGroupRcpt,
    rightToGroupRcpt,
    setRightToGroupRcpt,

    leftCcUserRcpt,
    setLeftCcUserRcpt,
    rightCcUserRcpt,
    setRightCcUserRcpt,

    leftCcGroupRcpt,
    setLeftCcGroupRcpt,
    rightCcGroupRcpt,
    setRightCcGroupRcpt,
  } = props;

  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    // console.log("User Group Type  | Variable: userGroupType (CirculationRecipientForm.js)"),
    // console.log(userGroupType),

    // console.log("User Group List  | Variable: userGroupList (CirculationRecipientForm.js)"),
    // console.log(userGroupList),

    // console.log("---------------------------------------------------------------------------------"),

    <Fragment>
      <div className={classes.root}>
        <AppBar position="static" color="default">
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="circulation tabs "
            textColor="primary"
            indicatorColor="primary"
          >
            <Tab key={0} label="Internal User" {...a11yProps(0)} />
            <Tab key={1} label="External User" {...a11yProps(0)} />
            {userGroupType !== null
              ? userGroupType.map((res, index) => {
                  return (
                    // <Tab key={res.type_seq} label={res.type_name} {...a11yProps(res.type_seq)} />
                    <Tab
                      key={index + 1}
                      label={res.type_name}
                      {...a11yProps(index + 1)}
                    />
                  );
                })
              : ""}
          </Tabs>
        </AppBar>

        <TabPanel key={0} value={tabValue} index={0}>
          {getUserListLoading}
          {internalUserList !== null ? (
            <TransferList
              listData={internalUserList}
              userType="internal"
              recipientType={recipientType}
              reciptentChipAdd={reciptentChipAdd}
              reciptentChipRemove={reciptentChipRemove}
              leftToUserRcpt={leftToUserRcpt}
              setLeftToUserRcpt={setLeftToUserRcpt}
              rightToUserRcpt={rightToUserRcpt}
              setRightToUserRcpt={setRightToUserRcpt}
              leftCcUserRcpt={leftCcUserRcpt}
              setLeftCcUserRcpt={setLeftCcUserRcpt}
              rightCcUserRcpt={rightCcUserRcpt}
              setRightCcUserRcpt={setRightCcUserRcpt}
            />
          ) : (
            ""
          )}
        </TabPanel>
        <TabPanel key={1} value={tabValue} index={1}>
          {getUserListLoading}
          {externalUserList !== null ? (
            <TransferList
              listData={externalUserList}
              userType="external"
              recipientType={recipientType}
              reciptentChipAdd={reciptentChipAdd}
              reciptentChipRemove={reciptentChipRemove}
              leftToUserRcpt={leftToUserRcpt}
              setLeftToUserRcpt={setLeftToUserRcpt}
              rightToUserRcpt={rightToUserRcpt}
              setRightToUserRcpt={setRightToUserRcpt}
              leftCcUserRcpt={leftCcUserRcpt}
              setLeftCcUserRcpt={setLeftCcUserRcpt}
              rightCcUserRcpt={rightCcUserRcpt}
              setRightCcUserRcpt={setRightCcUserRcpt}
            />
          ) : (
            ""
          )}
        </TabPanel>

        {userGroupType !== null
          ? userGroupType.map((res, index) => {
              return (
                // <TabPanel key={res.type_seq} value={tabValue} index={res.type_seq}>
                <TabPanel key={index + 2} value={tabValue} index={index + 2}>
                  {getGroupListLoading}
                  {userGroupList !== null ? (
                    <TransferGroupList
                      typeSeq={res.type_seq}
                      internalOnly={internalOnly}
                      listData={userGroupList}
                      recipientType={recipientType}
                      reciptentChipAdd={reciptentChipAdd}
                      reciptentChipRemove={reciptentChipRemove}
                      leftCcGroupRcpt={leftCcGroupRcpt}
                      setLeftCcGroupRcpt={setLeftCcGroupRcpt}
                      rightCcGroupRcpt={rightCcGroupRcpt}
                      setRightCcGroupRcpt={setRightCcGroupRcpt}
                      leftToGroupRcpt={leftToGroupRcpt}
                      setLeftToGroupRcpt={setLeftToGroupRcpt}
                      rightToGroupRcpt={rightToGroupRcpt}
                      setRightToGroupRcpt={setRightToGroupRcpt}
                    />
                  ) : (
                    ""
                  )}
                </TabPanel>
              );
            })
          : ""}
      </div>
    </Fragment>
  );
};

export default CirculationRecipientForm;
